"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormImportPoleforemanModal = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var store_1 = require("../../store");
var FORM_IMPORT_SUCCEED = { key: i18n_1.T.FORM_IMPORT_SUCCEED };
var FormImportPoleforemanModalCSS = {
    form: 'c-FormImportPoleforemanModal__form',
    spinner: 'c-FormImportPoleforemanModal__spinner'
};
(0, theme_1.addStyles)((_a = {},
    _a[FormImportPoleforemanModalCSS.form] = {
        display: 'flex',
        'flex-direction': 'column',
        gap: '10px',
        width: '400px',
        height: '80px'
    },
    _a[FormImportPoleforemanModalCSS.spinner] = {
        display: 'flex',
        'justify-content': 'center'
    },
    _a));
var FormImportPoleforemanModal = /** @class */ (function (_super) {
    tslib_1.__extends(FormImportPoleforemanModal, _super);
    function FormImportPoleforemanModal() {
        var _this = _super.call(this, {
            title: i18n_1.T.FORM_IMPORT_POLEFOREMAN,
            confirm: i18n_1.T.FORM_IMPORT_POLEFOREMAN_OK,
            success: FORM_IMPORT_SUCCEED
        }) || this;
        _this.loadingDatabases = false;
        _this.databaseURL = null;
        _this.databases = [];
        _this.refreshDatabases();
        return _this;
    }
    Object.defineProperty(FormImportPoleforemanModal.prototype, "nodes", {
        get: function () {
            var _this = this;
            if (this.loadingDatabases) {
                return (0, mithril_1.m)('div', { className: FormImportPoleforemanModalCSS.spinner }, spinner_1.Spinner.view());
            }
            return (0, mithril_1.m)('form', { className: FormImportPoleforemanModalCSS.form }, this.databases.length > 0 ? [
                (0, mithril_1.m)('div', [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_DESCRIPTION)]),
                (0, mithril_1.m)('select', {
                    onchange: function (e) {
                        if ('target' in e && e.target && 'value' in e.target && typeof e.target.value === 'string') {
                            _this.databaseURL = e.target.value;
                        }
                    },
                    selected: this.databaseURL,
                    disabled: this.loading
                }, tslib_1.__spreadArray([], this.databases.map(function (db) { return (0, mithril_1.m)('option', { value: db.databaseURL }, db.organizationName); }), true))
            ] : ((0, mithril_1.m)('div', [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_POLEFOREMAN_NO_DATABASES)])));
        },
        enumerable: false,
        configurable: true
    });
    FormImportPoleforemanModal.prototype.importPoleForemanForm = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setLoading(true);
                        rest = services_1.Services.Department.rest;
                        return [4 /*yield*/, rest.Form.Pla.importPoleforeman(tslib_1.__assign({}, (this.databaseURL && { databaseURL: this.databaseURL })))];
                    case 1:
                        _a.sent();
                        this.close();
                        store_1.AppStore.FormSummary.refresh();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormImportPoleforemanModal.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.importPoleForemanForm()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormImportPoleforemanModal.prototype.refreshDatabases = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, , 2, 3]);
                        this.loadingDatabases = true;
                        this.displaySubmitButton = false;
                        if (!((_a = services_1.Services.SSO.user) === null || _a === void 0 ? void 0 : _a.sub)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, services_1.Services.User.rest.User.ipfDatabases({ userId: (_b = services_1.Services.SSO.user) === null || _b === void 0 ? void 0 : _b.sub })];
                    case 1:
                        result = _c.sent();
                        this.databases = result.databases;
                        // Preselect the first result
                        if (result.databases.length > 0 && result.databases[0]) {
                            this.databaseURL = result.databases[0].databaseURL;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.displaySubmitButton = this.databases.length > 0;
                        this.loadingDatabases = false;
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "loadingDatabases", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportPoleforemanModal.prototype, "databases", void 0);
    return FormImportPoleforemanModal;
}(modal_form_component_1.ModalFormComponent));
exports.FormImportPoleforemanModal = FormImportPoleforemanModal;
//# sourceMappingURL=form.import.poleforeman.modal.js.map